<template>
  <div class="dischargeCapacity2">
    <title1 type="1" title="规划场站地区热榜" />
    <div style="width: 440px; height: 220px;">
      <MyEcharts
        v-if="showcdata"
        :id="'smart2_2'"
        :options="cdata"
      />
    </div>
  </div>
</template>

<script>
import title1 from "@/views/exposition/components/title4";
import MyEcharts from "@/views/exposition/components/charts/echarts.vue";
import * as echarts from "echarts5";
import { dataInterface } from "@/api/dataInterfaceApi";
export default {
  components: {
    MyEcharts,
    title1,
  },
  data() {
    return {
      showcdata: false,
      ydata: [78, 65, 64, 40],
      // title:"月度充/放电量"
      cdata: {
        tooltip: {
          trigger: "axis",
          show: true,
          axisPointer: {
            type: "cross",
            label: {
              // backgroundColor: "#6a7985",
            },
          },
          // textStyle: {
          //   fontSize: 50  // 设置字体大小为16px
          // }
          formatter:
            '<span style="font-size:20px;margin-left: 8px; float: right;">{a} <br/>{b} : {c}%</span>',
        },
        grid: {
          top: "23%",
          fontSize: 18,
        },

        color: ["rgba(26, 239, 239, 1)", "rgba(13, 109, 118, 0.42)"],
        xAxis: {
          type: "category",
          axisLabel: {
            //x轴文字的配置
            show: true,
            interval: 0, //使x轴文字显示全
          },
          boundaryGap: true,
          data: ["广东", "浙江", "江苏", "上海"],
        },
        title: {
          text: "单位: 座",
        },
        yAxis: {
          min: 0,
          max: 100,
          interval: 25,
          type: "value",
          nameTextStyle: {
            fontSize: 26,
          },
        },
        series: [
          {
            name: "场站数量",
            type: "pictorialBar",
            barWidth: 66,
            symbol: "path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z",
            smooth: true,
            data: [],
            tooltip: {
              valueFormatter: function (value) {
                return value + " %";
              },
            },
            itemStyle: {
              barBorderRadius: [2, 2, 0, 0], //柱体圆角
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  //代表渐变色从正上方开始
                  offset: 0, //offset范围是0~1，用于表示位置，0是指0%处的颜色
                  color: "rgba(255, 255, 255, 1)",
                },
                {
                  //代表渐变色从正上方开始
                  offset: 0.5, //offset范围是0~1，用于表示位置，0是指0%处的颜色
                  color: "rgba(26, 239, 239, 1)",
                }, //柱图渐变色
                {
                  offset: 0.9, //指100%处的颜色
                  color: "rgba(13, 109, 118, 0.42)",
                },
                {
                  offset: 1, //指100%处的颜色
                  color: "rgba(3, 13, 28, 0)",
                },
              ]),
            },
            lineStyle: {
              // color: "#FFCE51",
            },
            // areaStyle: {
            //   opacity: 0.8,
            //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            //     {
            //       offset: 0.4,
            //       color: "#0D6D76", // 0% 处的颜色
            //     },
            //     {
            //       offset: 1,
            //       color: "#1AEFEF", // 80% 处的颜色
            //     },
            //     {
            //       offset: 1,
            //       color: "#FFFFFF", // 100% 处的颜色
            //     },
            //   ]),
            // },
          },
        ],
      },
      query: this.$route.query,
    };
  },
  mounted() {
    this.$bus.$on("onfangdiangonglv", () => {
      this.getBattery24hours();
    });
    this.getBattery24hours();
  },
  destroyed() {
    // this.$bus.$off('onfangdiangonglv')
  },
  methods: {
    //获取24小时电次数分布
    getBattery24hours() {
      let cityCode = this.query.province || this.query.city || "000000";
      let params = {
        enCode: "zngf-qg-j24xsgsdfdxl", // 接口code
        // 接口传参
        "@adcode": cityCode,
      };
      this.showcdata = false;
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          console.log(res, "发电效率与收益排行榜");
          if (res) {
            let data = [];
            let data2 = [];
            let xAxis = [];
            res.forEach((item) => {
              xAxis.push(item.cur_hour); // 小时
              data.push(item.generate_electricity); // 发电效率
            });
            // this.cdata.xAxis.data = xAxis;
            this.cdata.series[0].data = this.ydata;
            this.showcdata = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style></style>
